// extracted by mini-css-extract-plugin
module.exports = {"header":"Users_header__1VXq8","headerUsersLabel":"Users_headerUsersLabel__1BV1f","usersList":"Users_usersList__qGgjq"};